<template>
  <TheNavbar
    nav-title="Partes de Reparación"
    class="secondary-navbar"
    :back-btn-enable="true"
    :back-callback="goBack"
    :add-btn-enable="true"
    @add-btn="emit('addClicked')"
  >
    <template #btn-right>
      <div
        class="navbar-location"
        :class="!geolocationError ? 'navbar-location__granted' : 'navbar-location__not-granted'"
        :title="`${!geolocationError ? 'Hay' : 'No hay'} acceso a la ubicación del usuario`"
      >
        <UCSvgIcon name="fa6-solid-street-view" />
      </div>
    </template>
  </TheNavbar>
</template>

<script setup>
// @ts-check
import { watch } from 'vue';
import { useGeolocation } from '@vueuse/core';
import { HiNotification } from '@/js/common/HINotificationSupport';

import TheNavbar from '@/components/TheNavbar.vue';
import UCSvgIcon from '@/components/common/UCSvgIcon.vue';
import { f7 } from 'framework7-vue';

const emit = defineEmits(['addClicked']);

const { error: geolocationError } = useGeolocation();

watch(geolocationError, (newValue) => {
  if (newValue) {
    HiNotification.Toast('No se ha podido obtener acceso a la ubicación');
  }
});

function goBack() {
  // Using `force` here to prevent going back to other page othen than main.
  // Without that, it was previously returning to the delivery note route
  // going back from 'Sign Later' button, the delivery note route instead of main page.
  f7.views.current.router.back('/', { force: true });
}
</script>

<style scoped lang="scss">
.navbar {
  :deep(.navbar-inner) {
    padding-right: 0;

    .left {
      max-width: calc(100% - 125px);
    }
  }

  .navbar-location {
    width: var(--f7-navbar-height);
    height: var(--f7-navbar-height);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: var(--f7-typography-margin);

    &__granted {
      background-color: var(--his-green);
    }

    &__not-granted {
      background-color: var(--his-red);
    }
  }
}
</style>
